import React, { useMemo } from "react";
import { SHELL } from "@/api/connectorPackClient";

export default function MomoRetryQueue({ audit }) {
  const retries = useMemo(() => (audit || []).filter((e) => e.event_type === "PAYOUT_RETRY_QUEUED"), [audit]);
  return (
    <div style={SHELL.panel} data-testid="momo-retry-queue">
      <h2 style={SHELL.h2}>MoMo Retry Queue · {retries.length}</h2>
      {retries.length === 0 ? (
        <div style={SHELL.dim}>No retries queued. Telecom-maintenance windows automatically transition failed disbursements to PENDING_RETRY.</div>
      ) : (
        <table style={{ ...SHELL.table, marginTop: 8 }}>
          <thead><tr><th style={SHELL.th}>Channel</th><th style={SHELL.th}>Reason</th><th style={SHELL.th}>When</th></tr></thead>
          <tbody>
            {retries.map((r) => (
              <tr key={r._id}>
                <td style={SHELL.td}>{r.connector_name}</td>
                <td style={SHELL.td}>{r.detail?.reason || "—"}</td>
                <td style={SHELL.td}>{(r.created_at || "").slice(0, 19)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
